import { Fragment } from 'react';

import useClubAdminChanges from './UseClubAdminChanges';

import ClubInactiveReasonDropdown from '../../../components/dropdowns/ClubInactiveReasonDropdown';

import Input from '@usas/ui-web/components/inputs/Input';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { LOADING_MSG, SAVING_MSG } from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubAdminChanges = () => {
  const {
    isSaving,
    isLoading,
    formState,
    errorState,
    onCancelClicked,
    onFormValueChanged,
    handleSubmit
  } = useClubAdminChanges();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Admin Changes</Headings.H3>
        </div>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            {formState.isClubCurrent === true ?
              <Input
                label="Club Name*"
                name="clubName"
                value={formState.clubName}
                error={errorState.clubName}
                message={errorState.clubName}
                onChange={(value) => { onFormValueChanged('clubName', value) }} /> :
              <ReadOnly
                label="Club Name"
                name="clubName"
                value={formState.clubName}
              />
            }
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            {formState.isClubCurrent === true ?
              <Input
                label="Club Code*"
                name="clubCode"
                value={formState.clubCode}
                error={errorState.clubCode}
                message={errorState.clubCode}
                onChange={(value) => { onFormValueChanged('clubCode', value) }} /> :
              <ReadOnly
                label="Club Code"
                name="clubCode"
                value={formState.clubCode}
              />
            }
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            {formState.isClubCurrent === true ?
              <YesNoSwitch
                label="Is Club Active?"
                name="isActive"
                checked={formState.isActive}
                error={errorState.isActive}
                message={errorState.isActive}
                onChange={(value) => { onFormValueChanged('isActive', value); }}
              /> :
              <ReadOnly
                label="Is Club Active?"
                name="isActive"
                value={formState.isActive === true ? 'Yes' : 'No'}
              />
            }
          </div>
          <div className={formState.isActive === false ? global.DisplayComponent : global.HideComponent}>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <ClubInactiveReasonDropdown
                label="Inactive Reason*"
                name="clubInactiveReasonId"
                value={formState.clubInactiveReasonId}
                error={errorState.clubInactiveReasonId}
                message={errorState.clubInactiveReasonId}
                onChange={(value) => { onFormValueChanged('clubInactiveReasonId', value); }}
              />
            </div>
          </div>
        </div>
        {formState.isClubCurrent === true ?
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
              <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
              <SecondaryButton type="button" onClick={onCancelClicked}>Cancel</SecondaryButton>
            </div>
          </div> : <Fragment />
        }
      </form >
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment >
  );
};

export default ClubAdminChanges;